<template>
    <!-- Manage list modal -->
    <!-- <b-modal scroll="keep" :aria-modal="true" :active="isChangePasswordFormVisible">
        <change-password />
    </b-modal> -->
    
    <b-modal v-model="isChangePasswordFormVisible" has-modal-card trap-focus :destroy-on-hide="false" aria-role="dialog"
    aria-label="Example Modal" close-button-aria-label="Close" aria-modal>
    <template #default="props">
        <change-password @close="props.close"></change-password>
    </template>
</b-modal>

<b-breadcrumb size="is-large" separator="has-succeeds-separator" aria-label="breadcrumbs">
    <b-breadcrumb-item active>
        {{ $t('global.settings') }}
    </b-breadcrumb-item>
</b-breadcrumb>
<div class="box">
    <h2 class="subtitle">{{ $t('settings.title') }}</h2>
    <b-field grouped position="is-left" :label="$t('settings.name')" :label-position="labelPosition">
        <b-input expanded v-model="form.firstName" :placeholder="$t('settings.firstNamePlaceholder')"></b-input>
        <b-input expanded v-model="form.lastName" :placeholder="$t('settings.lastNamePlaceholder')"></b-input>
    </b-field>
    <b-field :label="$t('settings.email')" :label-position="labelPosition" class="has-icons-left">
        <b-input type="email" icon="email" v-model="email" :placeholder="$t('settings.emailPlaceholder')"></b-input>
    </b-field>
    <b-field :label="$t('settings.language')" :label-position="labelPosition">
        <b-select v-model="form.language">
            <option value="en">English</option>
            <option value="de">Deutsch</option>
        </b-select>
    </b-field>
    <b-button type="is-danger" @click="isChangePasswordFormVisible = true">{{ $t('settings.changePassword') }}</b-button>
</div>
<div class="field is-grouped">
    <div class="control">
        <b-button type="is-primary" @click="save">{{ $t('global.save') }}</b-button>
    </div>
    <!-- <div class="control">
        <b-button @click="revert">{{ $t('global.cancel') }}</b-button>
    </div> -->
</div>
</template>

<script lang="ts">
import ChangePassword from '@/components/ChangePassword.vue';

export default {
    components: {
        ChangePassword,
    },
    inject: ['keycloak'],
    props: {
        user: Object,
    },
    data() {
        return {
            labelPosition: '',
            form: Object.assign({}, this.user),
            email: this.keycloak.idTokenParsed.preferred_username,
            isChangePasswordFormVisible: false,
        };
    },
    watch: {
        user: {
            immediate: true,
            handler(newVal) {
                this.form = Object.assign({}, newVal);
            },
        },
    },
    methods: {
        save() {
            this.$store.commit('setModel', { model: 'user', data: this.form });
            this.$store.dispatch('saveModel', { model : 'user' });
        },
        revert() {
            this.form = Object.assign({}, this.user);
        },
    }
};
</script>
